import { useAppState } from 'components/contexts/State';
import DocumentDataStep from './DocumentDataStep';
import {
  getDocumentData,
  getEditDocumentData,
  postDocumentDataModal,
  postEditDocumentData,
} from '../Services/DataRepoService';
import { useEffect, useState } from 'react';

function DocumentDataModalParent() {
  const {
    openDocumentDataModal,
    setOpenDocumentDataModal,
    setDocumentDataStepResponse,
    currProcessId,
    uploadStatusDetails,
    setUploadStatusDetails,
    setDisabledUploadDataBtn,
    editRowId,
    setDocumentData,
    setIsToasterMessageOpen,
    setToasterMessage,
    setToasterType,
  } = useAppState();

  const [saveInitialModalData, setSaveInitialModalData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleSaveDocDataParent = async (formData) => {
    if (openDocumentDataModal.value && openDocumentDataModal.isFromNotification) {
      handleSaveDocumentData(formData);
    } else {
      handleEditSaveDocData(formData);
    }
  };

  const handleSaveDocumentData = async (formData) => {
    let tempUploadStatus = [];
    uploadStatusDetails.forEach((ele) => {
      if (ele.step === 'Add details') ele.status = 'Completed';
      if (ele.step === 'Finalize') ele.status = 'In progress';
      tempUploadStatus.push(ele);
    });
    setUploadStatusDetails(tempUploadStatus);
    setOpenDocumentDataModal(false);
    try {
      let dataToSend = { ...formData };
      dataToSend.process_id = currProcessId;
      const res = await postDocumentDataModal(dataToSend);

      if (res) setDocumentDataStepResponse(res);
      tempUploadStatus = [];
      uploadStatusDetails.forEach((ele) => {
        if (ele.step === 'Add details') ele.status = 'Completed';
        if (ele.step === 'Finalize') ele.status = 'Completed';
        tempUploadStatus.push(ele);
      });
      setUploadStatusDetails(tempUploadStatus);
    } catch (error) {
      console.error(error.message);
      tempUploadStatus = [];
      uploadStatusDetails.forEach((ele) => {
        if (ele.step === 'Add details') ele.status = 'Completed';
        if (ele.step === 'Finalize') {
          ele.status = 'Error';
          ele.message = error.message;
        }
        tempUploadStatus.push(ele);
      });
      setUploadStatusDetails(tempUploadStatus);
    } finally {
      setDisabledUploadDataBtn(false);
    }
  };

  const handleFetchDocumentData = async () => {
    try {
      const response = await getDocumentData();
      if (response && response.length > 0) {
        setDocumentData(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleEditSaveDocData = async (formData) => {
    setIsLoading(true);
    try {
      let dataToSend = { ...formData };

      const res = await postEditDocumentData(editRowId, dataToSend);

      if (res) {
        await handleFetchDocumentData();
      }
    } catch (error) {
      console.error(error.message);
      if (error.status === 403) {
        setIsToasterMessageOpen(true);
        setToasterMessage(error.message);
        setToasterType('warning');
      }
    } finally {
      setIsLoading(false);
      setOpenDocumentDataModal({
        value: false,
        isFromNotification: openDocumentDataModal.isFromNotification,
      });
    }
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    return dateString.split('T')[0];
  };

  useEffect(() => {
    const handleEditGetData = async () => {
      try {
        const res = await getEditDocumentData(editRowId);
        if (res) {
          const dataObj = {
            data_creation_date: formatDateForInput(res.data_creation_date),
            document_title: res.document_title,
            public_link: res.public_link,
            data_refresh_date: formatDateForInput(res.data_refresh_date),
          };

          setSaveInitialModalData(dataObj);
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (openDocumentDataModal.value && !openDocumentDataModal.isFromNotification) {
      handleEditGetData();
    }
  }, [openDocumentDataModal.value, openDocumentDataModal.isFromNotification]);

  return (
    <>
      <DocumentDataStep
        open={openDocumentDataModal.value}
        isFromNotification={openDocumentDataModal.isFromNotification}
        onClose={() => {
          if (!isLoading) {
            setOpenDocumentDataModal({
              value: false,
              isFromNotification: openDocumentDataModal.isFromNotification,
            });
          }
        }}
        isLoading={isLoading}
        initialData={saveInitialModalData}
        onSave={handleSaveDocDataParent}
      />
    </>
  );
}

export default DocumentDataModalParent;
